import { Functions, httpsCallable } from 'firebase/functions';
import { CreateTeamFnReq, CreateTeamFnRes, Team } from '@uploadcam/common';
import { GetTeamByIdInteractor } from './get-team-by-id.interactor';
import { GetAuthDtoInteractor } from '../../../auth/domain/interactors/get-auth-dto.interactor';
import { Subject } from 'rxjs';

export class CreateTeamInteractor {
  private readonly createTeamFn = httpsCallable<CreateTeamFnReq, CreateTeamFnRes>(
    this.functions,
    'createTeam',
  );

  constructor(
    private readonly functions: Functions,
    private readonly getAuthDto: GetAuthDtoInteractor,
    private readonly getTeamById: GetTeamByIdInteractor,
    private readonly teamGetCurrent$: Subject<Team>,
  ) {}

  public async execute(data: Omit<CreateTeamFnReq, 'auth'>): Promise<Team> {
    const res = await this.createTeamFn({
      ...data,
      auth: await this.getAuthDto.execute(),
    });

    return this.getTeamById.execute(res.data.teamId).then((team) => {
      this.teamGetCurrent$.next(team);
      return team;
    });
  }
}
